import styled from 'styled-components';

import { Picture } from 'components/picture';
import {
  CardContainer,
  CardWrapper,
  LeftButtonWrapper,
  LeftCarouselButton,
  RightButtonWrapper,
  RightCarouselButton,
} from 'components/responsive-carousel/responsive-carousel.styled';

export const WidgetTitle = styled.h2`
  margin-block-end: 0;
`;

export const WidgetDescription = styled.p`
  margin-block-start: 0;
`;

export const Wrapper = styled.ul`
  margin: 0 auto;
  max-width: 770px;
  list-style: none;

  ${CardContainer} {
    margin: 0;
  }

  ${CardWrapper} {
    margin-inline-start: 16px;
  }

  ${RightCarouselButton},
  ${LeftCarouselButton} {
    background: ${Styles.color.white};
    color: ${Styles.color.black};
    padding-inline-start: 12px;
    > div > svg {
      fill: black;
    }
  }

  ${LeftButtonWrapper} {
    inset-inline-start: -25px;
  }

  ${RightButtonWrapper} {
    inset-inline-end: -25px;
  }
`;

export const CarouselItem = styled.div<{ backgroundColor: string }>`
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: ${Styles.boxShadow};
  padding: 20px;
`;

export const Title = styled.h2`
  margin-block-end: 0;
  font-family: ${Styles.fontFamily.base};
  text-align: start;
  padding: 0 1rem;

  ${Styles.desktop} {
    text-align: center;
  }
`;

export const ItemName = styled.span<{ color: string }>`
  color: ${({ color }) => color};
`;

export const Image = styled(Picture)`
  width: 150px;
  height: 150px;
`;

export const ItemPoints = styled.div`
  background-color: ${Styles.color.loyaltyHighlight};
  border-radius: 0.25rem;
  color: ${Styles.color.white};
  padding: 0.3125rem;
  margin-block-start: 0.3125rem;
  font-size: 0.625rem;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  gap: 0.3125rem;
`;

export const CarouselWrapper = styled.div``;
